<template lang="pug">
v-dialog(v-model="dialog" width="450px" scrollable)
  v-card(dark).pa-4
    p.title Создание новой группы
    v-text-field(
      v-model="form.title"
      filled
      label="Название группы"
    )
    .d-flex
      v-btn.mr-4(color="success" @click="submit") Сохранить
      v-btn(text @click="closeForm") Отменить
</template>
<script>
import groupServices, { CRUDGroups } from '@/services/API/client-question-groups';

const DEFAULT_FORM = {
  'title': '',
};
export default {
  props: {
    value: { type: Boolean, required: true },
    selected: { type: [Object, Number, Boolean, Array], default: false },
  },
  data() {
    return {
      dialog: false,
      form: { ...DEFAULT_FORM },
    };
  },
  watch:{
    value:{
      immediate: true,
      handler(v) {
        if (v && this.data) {
          this.form.title  = this.data.title;
        }
        this.dialog  = v;
      },
    },
    dialog(v) {
      this.$emit('input', v);
    },
  },
  methods: {
    closeForm(data) {
      this.form = DEFAULT_FORM;
      this.dialog = false;
      this.$emit('close', data);
    },
    async submit() {
      const params = this.form;
      try {
        const response = await CRUDGroups.create(params);
        const { id } = response.data.data;
        if (this.selected) groupServices.attach(id, { 'client_question_ids': [...this.selected] });
        this.$toast.success('Группа создана');
        this.closeForm(response.data.data);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
  },
};
</script>
<style scoped/>
